<template>
  <div class="pods-select-wrapper">
    <span class="pods-select-label">Pod</span>
    <el-select
      v-model="podId"
      filterable
      clearable
      size="small"
      placeholder="Select a pod"
      style="width: 240px"
      @change="handleChange"
      @clear="handleClear"
    >
      <el-option
        v-for="p in pods"
        :key="p.podId || ''"
        :label="p.podId || ''"
        :value="p.podId || ''"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      podId: '',
      pod: null,
      pods: this.$store.state.pods.pods || []
    }
  },
  props: {
    globalSync: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$store.dispatch('pods/fetchPods').then(() => {
      this.pods = this.$store.state.pods.pods || []
      if (this.globalSync) {
        const selected = this.$store.state.pods.selectedPod
        this.pod = selected || null
        this.podId = selected ? selected.podId || '' : ''
      }
    })
  },
  watch: {
    '$store.state.pods.selectedPod'(selected) {
      if (this.globalSync) {
        this.pod = selected || null
        this.podId = selected ? selected.podId || '' : ''
      }
    }
  },
  methods: {
    handleChange(podId) {
      const found = this.pods.find(p => p.podId === podId) || null
      this.pod = found
      if (this.globalSync) {
        this.$store.commit('pods/SET_SELECTED_POD', found || '')
      } else {
        this.$emit('updateData')
      }
    },
    handleClear() {
      this.pod = null
      this.podId = ''
      if (this.globalSync) {
        this.$store.commit('pods/SET_SELECTED_POD', '')
      } else {
        this.$emit('updateData')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pods-select-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4b5563;
  white-space: nowrap;
}
.pods-select-label {
  font-weight: 500;
}
</style>
